// extracted by mini-css-extract-plugin
export default {"roundLabel":"styles_roundLabel__oMs5X","allow":"styles_allow__cQsis","pending":"styles_pending__KJnmc"};